import { FileBarChart } from 'lucide-react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui'
import { TimesheetReport } from '../components/reports/TimesheetReport'
import { LatenessReport } from '../components/reports/LatenessReport'
import { NoScheduleReport } from '../components/reports/NoScheduleReport'
import { ScheduleEffectivenessReport } from '../components/reports/ScheduleEffectivenessReport'
import { SalariesReport } from '../components/reports/SalariesReport'
import { RevenueVsPayrollReport } from '../components/reports/RevenueVsPayrollReport'
import { TalentReport } from '../components/reports/TalentReport'
import { WaiterExcellenceReport } from '../components/reports/WaiterExcellenceReport'

export function Reports() {
  return (
    <div className="space-y-6 flex-1 overflow-auto">
      {/* Header */}
      <div className="flex items-center gap-3">
        <FileBarChart className="h-8 w-8 text-primary" />
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Отчеты</h1>
          <p className="text-muted-foreground">
            Аналитика и отчеты по посещаемости сотрудников
          </p>
        </div>
      </div>

      {/* Tabs */}
      <Tabs defaultValue="timesheet" className="space-y-4">
        <TabsList>
          <TabsTrigger value="timesheet">Табель</TabsTrigger>
          <TabsTrigger value="lateness">Опоздания</TabsTrigger>
          <TabsTrigger value="off-schedule">Вне графика</TabsTrigger>
          <TabsTrigger value="schedule-effectiveness">Эффективность графиков</TabsTrigger>
          <TabsTrigger value="salaries">Зарплаты</TabsTrigger>
          <TabsTrigger value="revenue-vs-payroll">Выручка к ФОТ</TabsTrigger>
          <TabsTrigger value="talent">Талант</TabsTrigger>
          <TabsTrigger value="waiter-excellence">Отличники-официанты</TabsTrigger>
        </TabsList>

        <TabsContent value="timesheet">
          <TimesheetReport />
        </TabsContent>

        <TabsContent value="lateness">
          <LatenessReport />
        </TabsContent>

        <TabsContent value="off-schedule">
          <NoScheduleReport />
        </TabsContent>

        <TabsContent value="schedule-effectiveness">
          <ScheduleEffectivenessReport />
        </TabsContent>

        <TabsContent value="salaries">
          <SalariesReport />
        </TabsContent>

        <TabsContent value="revenue-vs-payroll">
          <RevenueVsPayrollReport />
        </TabsContent>

        <TabsContent value="talent">
          <TalentReport />
        </TabsContent>

        <TabsContent value="waiter-excellence">
          <WaiterExcellenceReport />
        </TabsContent>
      </Tabs>
    </div>
  )
}
